import React, { createContext, useContext, useState } from 'react'
import useModalTransition from '../utils/useModalTransition'

const ListModalContext = createContext()

export const useListModal = () => {
  return useContext(ListModalContext)
}

export const FilterModalProvider = ({ children }) => {
  const [showListModal, setShowListModal] = useState(false)
  const {
    shouldRender: shouldRenderListModal,
    isClosing: isListModalClosing,
  } = useModalTransition(showListModal)

  const listModalState = {
    showListModal,
    setShowListModal,
    shouldRenderListModal,
    isListModalClosing,
  }

  return (
    <ListModalContext.Provider value={listModalState}>
      {children}
    </ListModalContext.Provider>
  )
}
